import { createSlice } from '@reduxjs/toolkit'

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    userDetails: {},
    screenRoutes: [],
    stageMasterName: [],
    stageName: "",
  },
  reducers: {
    updateAuthCheckParams: (state, { payload }) => {
      state.userDetails = payload || state?.userDetails
    },
    setScreenRoutes: (state, { payload }) => {
      state.screenRoutes = payload;
    },
    setMenuData: (state, { payload }) => {
      state.menus = payload;
    },

    onLogout: (state, { payload }) => {
      state.userDetails = {};
      state.screenRoutes = [];
      state.menus=[]
    },

    setStageMasterName: (state, { payload }) => {
      state.stageMasterName = payload || state?.stageMasterName;
    },

    setStageName: (state, { payload }) => {
      state.stageName = payload || state?.stageName;
    },
  },
})

export const {
  updateAuthCheckParams,
  setScreenRoutes,
  onLogout,
  setStageMasterName,
  setStageName,
  setMenuData
} = commonSlice.actions

